import createLazyPlugin from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import PluginNames from 'owa-editor-lazy-plugin/lib/utils/PluginNames';
import { LazyModule } from 'owa-bundling';
import { PluginEventType } from 'roosterjs-editor-types';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "HtmlEditorLazyPlugins" */ './lazyIndex')
);

export const ContentEdit = createLazyPlugin(
    lazyModule,
    m => m.ContentEdit,
    PluginNames.ContentEdit,
    trigger
);
export const HyperLink = createLazyPlugin(
    lazyModule,
    m => m.HyperLink,
    PluginNames.HyperLink,
    trigger
);
export const Paste = createLazyPlugin(lazyModule, m => m.Paste, PluginNames.Paste, trigger);
export const TableResize = createLazyPlugin(
    lazyModule,
    m => m.TableResize,
    PluginNames.TableResize,
    trigger
);
export const Watermark = createLazyPlugin(
    lazyModule,
    m => m.OwaWatermark,
    PluginNames.Watermark,
    trigger
);
export const ImageEdit = createLazyPlugin(
    lazyModule,
    m => m.OwaImageEdit,
    PluginNames.ImageEdit,
    trigger
);
export const ContextMenu = createLazyPlugin(
    lazyModule,
    m => m.OwaContextMenu,
    PluginNames.ContextMenu,
    trigger
);
export const CustomReplace = createLazyPlugin(
    lazyModule,
    m => m.OwaCustomReplace,
    PluginNames.CustomReplace,
    trigger
);
export const CutPasteListChain = createLazyPlugin(
    lazyModule,
    m => m.CutPasteListChain,
    PluginNames.CutPasteListChain,
    trigger
);
export const ListEdit = createLazyPlugin(lazyModule, m => m.ListEdit, PluginNames.ListEdit);

function trigger(event) {
    return event.eventType == PluginEventType.EditorReady;
}
